var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Back',{staticClass:"back",attrs:{"black":""}}),_c('div',{staticClass:"list"},[_c('RegisterSocialNetwork'),_vm._l((_vm.socialNetworks),function(sn){return _c('SocialNetwork',{key:sn.id,attrs:{"sn":sn}})}),_c('JoinSocialNetwork')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }